import script from "./SolutionIndustrySection.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionIndustrySection.vue?vue&type=script&setup=true&lang=js"

import "./SolutionIndustrySection.vue?vue&type=style&index=0&id=39104d13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39104d13"]])

export default __exports__